<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="" class="pb-2">
      <!-- <b-card-text>Privilege.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <div class="d-flex justify-content-between flex-wrap">
            <!-- Parent -->
            <b-col cols="12" class="ml-1">
              <b-form-group label="Parent" label-for="v-parent">
                <validation-provider #default="{ errors }" name="Parent" rules="required">
                  <v-select id="v-parent" v-model="form.select_1" placeholder="Chose Parent" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="ParentOptions" :reduce="ParentOptions => ParentOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Level -->
            <b-col cols="12" class="ml-1">
              <b-form-group label="Level" label-for="v-level">
                <validation-provider #default="{ errors }" name="Level" rules="required" >
                  <b-form-input id="v-level" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Level" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Code -->
            <b-col cols="12" class="ml-1">
              <b-form-group label="Code" label-for="v-product-code">
                <validation-provider #default="{ errors }" name="Code" rules="required" >
                  <b-form-input id="v-product-code" :state="errors.length > 0 ? false:null" v-model="form.text_3" placeholder="Code" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </div>
          <div class="d-flex justify-content-between flex-wrap">
            <!-- Name -->
            <b-col cols="12" class="ml-1">
              <b-form-group label="Name" label-for="v-product-name">
                <validation-provider #default="{ errors }" name="Name" rules="required">
                  <b-form-input id="v-product-name" :state="errors.length > 0 ? false:null" v-model="form.text_4" placeholder="Name" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Order -->
            <b-col cols="12" class="ml-1">
              <b-form-group label="Order" label-for="v-product-order">
                <validation-provider #default="{ errors }" name="Order" rules="required">
                  <b-form-input id="v-product-order" type="number" :state="errors.length > 0 ? false:null" v-model="form.text_8" placeholder="Order" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Icon -->
            <b-col cols="12" class="ml-1">
              <b-form-group label="Icon" label-for="v-product-icon">
                <validation-provider #default="{ errors }" name="Icon">
                  <b-form-input id="v-product-icon" :state="errors.length > 0 ? false:null" v-model="form.text_5" placeholder="Icon"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </div>
          <div class="d-flex justify-content-between flex-wrap">
            <!-- Slug -->
            <b-col cols="12" class="ml-1">
              <b-form-group label="Slug" label-for="v-product-slug">
                <validation-provider #default="{ errors }" name="Slug" >
                  <b-form-input id="v-product-icon" :state="errors.length > 0 ? false:null" v-model="form.text_6" placeholder="Slug"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Category -->
            <b-col cols="12" class="ml-1">
              <b-form-group label="Url" label-for="v-product-url">
                <validation-provider #default="{ errors }" name="Url">
                  <b-form-input id="v-product-url" :state="errors.length > 0 ? false:null" v-model="form.text_7" placeholder="Url"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </div>
            <!-- submit and reset -->
            <b-col cols="12" class="ml-1">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
              <!--Privillage-->
    <!-- <b-card-code title="" no-body>
      <div class="mt-1">
          <b-button class="ml-1 mb-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" v-b-modal.modal-select2>
        <feather-icon icon="PlusIcon" /> Add
        </b-button>
      </div>
      <b-modal
        id="modal-select2"
        title="Basic Modal"
        ok-title=""
        cancel-title=""
        cancel-variant="outline-secondary"
        v-model="modalShow"
        @click.prevent="addToTempTable"
      >
      <b-form @submit.prevent="addToTempTable" >
        <b-form-group label="Code" label-for="code">
            <b-form-input v-model="tempData.code" id="code" required/>
          </b-form-group>
          <b-form-group label="Name" label-for="name">
            <b-form-input v-model="tempData.name" id="name" required/>
          </b-form-group>
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="addToTempTable"> Submit </b-button>
      </b-form>
      </b-modal>
      <div><div class="h-50 d-inline-block"></div></div>
      <div class="d-flex justify-content-between flex-wrap">
        <b-table striped hover responsive class="position-relative" :items="tempTable" :fields="fieldsTemp">
          <template #cell(action)="row"> 
          <span>
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
              <template v-slot:button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
              </template>
              <b-dropdown-item>
                <b-link v-b-modal.modal-center
                @click="removeItem(index)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete</span>
                </b-link>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </template>
        </b-table>
      </div>
  </b-card-code> -->
  </b-overlay>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCol, BFormGroup, BFormInput, BForm, BButton, BCard, BCardText, BModal, VBModal, BDropdownItem, BDropdown, BLink, BCardBody, BInputGroupAppend, BInputGroup, BPagination, BFormSelect, BBadge, BTable, BAvatar } from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapState } from 'vuex'
export default {
  components: { vSelect, BOverlay, ValidationProvider, ValidationObserver, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton,BCardText, BModal, VBModal, ToastificationContent, BDropdownItem, BDropdown, BLink, BCardBody, BInputGroupAppend, BInputGroup, BPagination, BFormSelect, BBadge, BCardCode, BTable, BAvatar },
  directives: { Ripple, 'b-modal' : VBModal },
  data () {
    return { 
      form: {id: null, select_1: '',text_2: '',text_3: '',text_4: '',text_5: '',text_6: '',text_7: '',text_8: ''},
      show: false,
      required,
      dir: false,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
          id: 'info-modal',
          title: '',
          content: '',
      },
      status: [{
          AC: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
          AC: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      modalShow: false,
      tempData: {
         id : 0,
         code :'',
         name :'',
        },
      tempTable: [],
      fieldsTemp:[
        { key: 'id', label: 'No', sortable: true },
        { key: 'code', label: 'Code', sortable: true },
        { key: 'name', label: 'name', sortable: true },
        { key: 'action', label: 'Action'},
      ]
    }
  },
  computed: {
    ...mapState({ 
      ParentOptions: state => state.privilegeCategory.options,
      totalRows: state => state.privilegeCategory.totalRows,
      fields: state => state.privilegeCategory.fields,
      items: state => state.privilegeCategory.items,
      perPage: state => state.privilegeCategory.perPage,
      pageOptions: state => state.privilegeCategory.pageOptions,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fieldsTemp
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    }
  },
  created () {
    this.$store.dispatch('privilegeCategory/getAll')
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
          const formTable = this.tempTable
			    this.$store.dispatch('privilegeCategory/formPostPut', formData,formTable)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            console.log(err)
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('privilegeCategory/getById', id).then(data => {
        this.form.id = data.id
        this.form.select_1 = data.parent_id
        this.form.text_2 = data.level
        this.form.text_3 = data.code
        this.form.text_4 = data.name
        this.form.text_5 = data.icon
        this.form.text_6 = data.slug
        this.form.text_7 = data.url
        this.form.text_8 = data.order
        this.show = false
      })
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    showModal() {
      this.modalShow = true;
    },
    addToTempTable() {
      this.tempData.id++
      this.tempTable.push({ ...this.tempData });
      this.tempData.code = '';
      this.tempData.name = '';
    },
    removeItem(index) {
    this.tempTable.splice(index, 1);
  }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
    this.$store.state.totalRows = this.items.length
  },
  created () {
    this.$store.dispatch('privilegeCategory/getAll')
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>